import { apiClient } from "@/api/api-client";
import { useEffect, useState } from "react";
import Combobox from "../core/forms/combobox";

type Item = {
	year: number;
	case_category_name: string;
	total: number;
};

const CaseYearCategoryChart = () => {
	const [data, setData] = useState<Array<Item> | []>([]);
	const [years, setYears] = useState<Array<number> | []>([]);
	const [categories, setCategories] = useState<Array<string> | []>([]);
	const [totals, setTotals] = useState<Array<number> | []>([]);
	const [brackets, setBrackets] = useState([]);

	const fetchYearBrackets = async () => {
		const response = await apiClient.get("/case-year-bracket");

		const data = response.data.map((item) => ({
			value: item,
			label: `${item.start_year}-${item.end_year}`,
		}));

		if (response && response.data) {
			setBrackets(data);
			console.log(brackets);
		}
	};

	const fetchStatistics = async (start = null, end = null) => {
		const response = await apiClient.get(`/backoffice/case-per-year-per-category?start_year=${start}&end_year=${end}`);

		if (response && response.data) {
			setData(response.data.data);
			setYears(response.data.meta.years);
			setCategories(response.data.meta.categories);
			setTotals(response.data.meta.totals);
		}
	};

	const ParentTable = () => {
		return (
			<div className="flex flex-col w-full relative overflow-x-auto">
				<table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
					<thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
						<tr>
							<th className="px-6 py-3"></th>
							{years.length > 0
								? years.map((year: number, yIndex) => (
										<th key={`year-${yIndex}`} className="px-6 py-3">
											{year}
										</th>
									))
								: null}
						</tr>
					</thead>
					<tbody>
						{categories.length && data.length
							? categories.map((category, cIndex) => (
									<tr key={`category-${cIndex}`} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
										<td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{category}</td>
										{years.map((year, yIndex) => {
											const item = data.find((d) => d.case_category_name === category && d.year === year);
											return (
												<td key={`category-${cIndex}-year-${yIndex}`} className="px-6 py-4 text-right">
													{item ? item.total : 0}
												</td>
											);
										})}
									</tr>
								))
							: null}
					</tbody>
					<tfoot>
						<tr className="font-semibold text-gray-900 dark:text-white">
							<th scope="row" className="px-6 py-3 text-base">
								Total
							</th>
							{totals.length
								? totals.map((total, tIndex) => (
										<th scope="row" className="px-6 py-3 text-base text-right" key={`total-${tIndex}`}>
											{total}
										</th>
									))
								: null}
						</tr>
					</tfoot>
				</table>
			</div>
		);
	};

	const loadOptions = async () => {
		const items = await apiClient.get("/case-year-bracket");

		return items.data.map((item) => ({
			value: item,
			label: `${item.start_year}-${item.end_year}`,
		}));
	};

	useEffect(() => {
		fetchYearBrackets();
		fetchStatistics();
	}, []);

	return (
		<div className="grid grid-cols-12 w-full gap-4">
			<div className="col-span-12">
				<div className="flex flex-col w-full gap-4">
					<div className="flex flex-col w-full h-auto rounded-md border border-border/50 overflow-hidden">
						<div className="flex flex-row w-full p-3 border-b border-border/50 items-center">
							<div className="flex flex-col w-9/12 text-base font-semibold text-foreground-dark">Cases Per Year Per Category</div>
							<div className="flex flex-col w-3/12 text-base font-semibold text-foreground-dark">
								{brackets.length && (
									<Combobox
										onValueChange={(value) => {
											fetchStatistics(value.value.start_year, value.value.end_year);
										}}
										returnFullOption={true}
										clearable={false}
										placeholderValue={{
											label: "2025 - 2029",
											value: {
												start_year: 2025,
												end_year: 2029,
											},
										}}
										defaultValue={{
											label: "2025 - 2029",
											value: {
												start_year: 2025,
												end_year: 2029,
											},
										}}
										loadOptions={loadOptions}
									/>
								)}
							</div>
						</div>
						<ParentTable />
					</div>
				</div>
			</div>
		</div>
	);
};

export default CaseYearCategoryChart;
